// CosyPlants bundle:
// - Filter pot cards by selected main product Size
// - Add main + selected pot + selected add-ons in ONE request
// Requires HTML:
// - Bundle root: [data-cosy-bundle-root]
// - Pot radios: .cosy-pot-option (value="" for no pot, else variant id)
// - Add-on checkboxes: .cosy-addon-checkbox (value=variant id)
// - Pot card labels have: data-cosy-pot-size="small|medium|large|extra large|huge" (empty for No pot)
// - Abbreviated size labels supported: S/M/L/XL (with or without parenthetical, e.g. "S (Small)")

(function () {
  const ALLOWED = ['small', 'medium', 'large', 'extra large', 'huge'];

  const SIZE_ALIASES = {
    's':   'small',
    'm':   'medium',
    'l':   'large',
    'x':   'large',
    'xl':  'extra large',
    'xxl': 'huge',
  };

  function norm(s) {
    return (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  // Strips parenthetical suffix ("S (Small)" → "s") then resolves abbreviation → full word
  function canonicalSize(s) {
    const base = norm(s).replace(/\s*\(.*\)$/, '').trim();
    return SIZE_ALIASES[base] || base;
  }

  function isAllowedSize(s) {
    return ALLOWED.includes(canonicalSize(s));
  }

  // --- Detect selected size from common theme patterns ---
  function getSelectedSizeFromButtons() {
    // Themes often toggle aria-pressed or active classes on option buttons
    const candidates = [
      ...document.querySelectorAll('[aria-pressed="true"]'),
      ...document.querySelectorAll('.is-active, .active, .selected')
    ];

    for (const el of candidates) {
      const t = norm(el.textContent);
      if (isAllowedSize(t)) return canonicalSize(t);
    }

    // Some themes show "Size: Small" text somewhere
    const sizeLine = document.querySelector('[data-size], .product-size, .variant-size, .size-value');
    if (sizeLine) {
      const t = norm(sizeLine.textContent);
      for (const s of ALLOWED) {
        if (t === s || t.includes(` ${s} `) || t.endsWith(` ${s}`)) return canonicalSize(s);
      }
    }

    return null;
  }

  function getSelectedSizeFromRadios() {
    // If size is a radio option
    const checkedRadios = Array.from(document.querySelectorAll('input[type="radio"]:checked'));
    for (const r of checkedRadios) {
      const v = norm(r.value);
      if (isAllowedSize(v)) return canonicalSize(v);

      const label = r.closest('label');
      if (label) {
        const t = norm(label.textContent);
        for (const s of ALLOWED) {
          if (t === s || t.includes(` ${s} `) || t.endsWith(` ${s}`) || t.startsWith(`${s} `)) return canonicalSize(s);
        }
      }
    }
    return null;
  }

  function getSelectedSizeFromSelects() {
    // If size is a dropdown select
    const selects = Array.from(document.querySelectorAll('select'));
    for (const s of selects) {
      const txt = norm(s.options[s.selectedIndex]?.text || s.value);
      if (isAllowedSize(txt)) return canonicalSize(txt);
    }
    return null;
  }

  function getSelectedPlantSize() {
    return (
      getSelectedSizeFromRadios() ||
      getSelectedSizeFromButtons() ||
      getSelectedSizeFromSelects()
    );
  }

  // --- Detect selected size scoped to the sticky cart element ---
  function getSelectedSizeFromStickyCart() {
    const stickyEl = document.querySelector('sticky-addtocart');
    if (!stickyEl) return null;

    const checkedRadios = Array.from(stickyEl.querySelectorAll('input[type="radio"]:checked'));
    for (const r of checkedRadios) {
      const v = norm(r.value);
      if (isAllowedSize(v)) return canonicalSize(v);
      // Handle "S (10 cm - 15 cm)" style values
      const cs = canonicalSize(v);
      if (ALLOWED.includes(cs)) return cs;
    }

    const activeEls = Array.from(stickyEl.querySelectorAll('.active'));
    for (const el of activeEls) {
      const t = norm(el.textContent);
      if (isAllowedSize(t)) return canonicalSize(t);
      const cs = canonicalSize(t);
      if (ALLOWED.includes(cs)) return cs;
    }

    return null;
  }

  // --- Filter sticky cart pot cards ---
  function filterStickyPotCards() {
    const root = document.querySelector('[data-cosy-sticky-bundle-root]');
    if (!root) return;

    const plantSize = norm(getSelectedSizeFromStickyCart() || getSelectedPlantSize());
    const potCards = Array.from(root.querySelectorAll('[data-cosy-pot-size]'));
    if (!potCards.length) return;

    if (!plantSize) {
      potCards.forEach((c) => (c.style.display = ''));
      return;
    }

    potCards.forEach((card) => {
      const potSize = canonicalSize(card.getAttribute('data-cosy-pot-size') || '');
      card.style.display = (potSize === plantSize) ? '' : 'none';
    });

    const selectedPot = root.querySelector('.cosy-sticky-pot-option:checked');
    if (selectedPot && selectedPot.value) {
      const label = selectedPot.closest('label');
      if (label && label.style.display === 'none') {
        const firstVisible = potCards.find(c => c.style.display !== 'none');
        if (firstVisible) firstVisible.querySelector('.cosy-sticky-pot-option').checked = true;
      }
    }
  }

  // --- Filter pot cards ---
  function filterPotCards() {
    const root = document.querySelector('[data-cosy-bundle-root]');
    if (!root) return;

    const plantSize = norm(getSelectedPlantSize());
    const potCards = Array.from(root.querySelectorAll('[data-cosy-pot-size]'));
    if (!potCards.length) return;

    // If we can't detect size, show all.
    if (!plantSize) {
      potCards.forEach((c) => (c.style.display = ''));
      return;
    }

    potCards.forEach((card) => {
      const potSize = canonicalSize(card.getAttribute('data-cosy-pot-size') || '');
      card.style.display = (potSize === plantSize) ? '' : 'none';
    });

    // If selected pot became hidden, select first visible pot
    const selectedPot = root.querySelector('.cosy-pot-option:checked');
    if (selectedPot && selectedPot.value) {
      const label = selectedPot.closest('label');
      if (label && label.style.display === 'none') {
        const firstVisible = potCards.find(c => c.style.display !== 'none');
        if (firstVisible) firstVisible.querySelector('.cosy-pot-option').checked = true;
      }
    }
  }

  // --- Add-to-cart helpers ---
  // NOTE: hooks are attached via delegation scoped to [data-js-product]
  // (see below), not to a specific form captured once at page load.
  //
  // Important: the "Quick View" / "Select Options" modal
  // (templates/product.ajax-edit-cart.liquid, opened via editCart() in
  // theme.js) has NO <form> element at all - the bundle root sits in a bare
  // <div data-js-product>. Scoping on `.closest('form')` silently fails
  // there, so this must key off [data-js-product], which is present on
  // every add-to-cart surface: the PDP (<product-single data-js-product>),
  // this modal, and the sticky bar (<sticky-addtocart data-js-product>).
  function getMainVariantId(container) {
    const idInput = container.querySelector('input[name="id"]');
    if (idInput && idInput.value) return Number(idInput.value);

    const idSelect = container.querySelector('select[name="id"]');
    if (idSelect && idSelect.value) return Number(idSelect.value);

    return null;
  }

  function getQuantity(container) {
    const qtyInput =
      container.querySelector('input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');

    const n = qtyInput ? Number(qtyInput.value || 1) : 1;
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function hasExtrasSelected(root) {
    const pot = root.querySelector('.cosy-pot-option:checked, .cosy-sticky-pot-option:checked');
    const addons = root.querySelectorAll('.cosy-addon-checkbox:checked');
    return (pot && pot.value) || (addons && addons.length > 0);
  }

  async function submitBundle(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const txt = await res.text();
      console.error('CosyPlants bundle add failed:', txt);
      return false;
    }

    return true;
  }

  // theme.js's own cart-mutation listeners (e.g. mainCart()'s totals
  // refresh on the /cart page) read `event.detail.response.items` etc.
  // unconditionally, so a bare `{}` detail throws there. Fetch the current
  // cart and use it as `response` so any listener - ours or the theme's -
  // sees a normally-shaped payload.
  async function dispatchCartRefresh(eventName) {
    let response = null;
    try {
      response = await fetch('/cart.js').then((r) => r.json());
    } catch (err) {
      console.error(err);
    }
    document.body.dispatchEvent(new CustomEvent(eventName, { detail: { response } }));
  }

  // Hidden (underscore-prefixed, so Shopify hides it from the customer)
  // line item property linking a bundled pot/add-on back to the plant
  // variant it was added with. Lets reconcileOrphanedPots() find and
  // remove a free pot whose plant was later deleted from the cart.
  const BUNDLE_PARENT_PROPERTY = '_cosy_bundle_parent';

  function addBundleToCart(container, root) {
    const mainId = getMainVariantId(container);
    if (!mainId) return Promise.resolve(false);

    const qty = getQuantity(container);
    const items = [{ id: mainId, quantity: qty }];

    const selectedPot = root.querySelector('.cosy-pot-option:checked, .cosy-sticky-pot-option:checked');
    if (selectedPot && selectedPot.value) {
      items.push({
        id: Number(selectedPot.value),
        quantity: qty,
        properties: { [BUNDLE_PARENT_PROPERTY]: String(mainId) }
      });
    }

    const addons = Array.from(root.querySelectorAll('.cosy-addon-checkbox:checked'))
      .map((cb) => Number(cb.value))
      .filter((v) => Number.isFinite(v) && v > 0);

    addons.forEach((id) => items.push({
      id,
      quantity: qty,
      properties: { [BUNDLE_PARENT_PROPERTY]: String(mainId) }
    }));

    // If no extras, let theme handle normal add-to-cart
    if (items.length === 1) return Promise.resolve(false);

    return submitBundle(items);
  }

  // --- Orphaned free-pot/add-on cleanup ---
  // If the plant a pot/add-on was bundled with gets removed from the cart
  // (or its quantity drops to 0), the pot is left behind as a free-standing
  // Rs 0.00 item with nothing to be "free with". Whenever the cart changes,
  // check for bundled items whose parent plant variant is no longer present
  // and remove them too.
  let reconcileBusy = false;

  async function reconcileOrphanedPots() {
    if (reconcileBusy) return;
    reconcileBusy = true;

    try {
      const cart = await fetch('/cart.js').then((r) => r.json());

      const plantVariantIds = new Set(
        cart.items
          .filter((item) => !(item.properties && item.properties[BUNDLE_PARENT_PROPERTY]))
          .map((item) => item.variant_id)
      );

      const orphans = cart.items.filter((item) => {
        const parentId = item.properties && item.properties[BUNDLE_PARENT_PROPERTY];
        return parentId && !plantVariantIds.has(Number(parentId));
      });

      for (const orphan of orphans) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: orphan.key, quantity: 0 })
        });
      }

      if (orphans.length) {
        await dispatchCartRefresh('ajax:deleteCart');
      }
    } catch (err) {
      console.error('CosyPlants bundle: orphaned pot cleanup failed', err);
    } finally {
      reconcileBusy = false;
    }
  }

  // Fires on remove-item clicks (ajax:deleteCart) and quantity changes
  // (drawer:Minicart) - the two cart-mutation events theme.js dispatches.
  document.body.addEventListener('ajax:deleteCart', reconcileOrphanedPots);
  document.body.addEventListener('drawer:Minicart', reconcileOrphanedPots);

  // Also sweep once on load, in case a pot was orphaned in a previous visit
  // (e.g. cart saved before this cleanup existed).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcileOrphanedPots);
  } else {
    reconcileOrphanedPots();
  }

  function findBundleContext(el) {
    const container = el.closest('[data-js-product]');
    if (!container) return null;

    const root = container.querySelector('[data-cosy-bundle-root], [data-cosy-sticky-bundle-root]');
    return root ? { container, root } : null;
  }

  let bundleBusy = false;

  function handleBundleIntercept(e, contextEl) {
    const ctx = findBundleContext(contextEl);
    if (!ctx || !hasExtrasSelected(ctx.root)) return; // let default add-to-cart happen

    e.preventDefault();
    e.stopPropagation();
    if (bundleBusy) return;
    bundleBusy = true;

    addBundleToCart(ctx.container, ctx.root)
      .then((added) => {
        bundleBusy = false;
        if (!added) {
          console.error('CosyPlants bundle: could not resolve the main product variant to add to cart.');
          return;
        }

        // Refresh the popup cart the same way every other add-to-cart path
        // on this theme does (Alothemes.miniCart() falls back to fetching
        // cart?section_id=minicart when no sections are in the detail).
        dispatchCartRefresh('ajax:addToCart');

        // Mirror Alothemes.addItemToCart's own post-add behavior: open the
        // sidebar cart drawer so the user actually sees what was added.
        if (window.ajaxcart && window.ajaxcart.ajaxcartAfter === 'sidebar_cart') {
          const minicart = document.querySelector('.minicart .push_side');
          if (minicart && !minicart.classList.contains('active')) minicart.click();
        }

        // Quick View / Select Options renders inside a <dialog>; close it
        // the same way dialog-modal.js normally does on add-to-cart.
        const dialog = contextEl.closest('dialog');
        if (dialog && typeof dialog.close === 'function') dialog.close();
      })
      .catch((err) => {
        console.error(err);
        bundleBusy = false;
      });
  }

  // Delegated + scoped to [data-js-product] so it works for any add-to-cart
  // surface present now or injected later (Quick View modal), instead of a
  // stale one-time element reference.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(
      'button[type="submit"], button[name="add"], .add-to-cart, .single_add_to_cart_button'
    );
    if (!btn) return;
    handleBundleIntercept(e, btn);
  }, true);

  document.addEventListener('submit', (e) => {
    if (!(e.target instanceof HTMLFormElement)) return;
    handleBundleIntercept(e, e.target);
  }, true);

  function init() {
    // Filter once at start
    filterPotCards();
    filterStickyPotCards();

    // Re-filter when size changes (click or change)
    document.addEventListener('change', () => {
      setTimeout(filterPotCards, 50);
      setTimeout(filterStickyPotCards, 50);
    });
    document.addEventListener('click', () => {
      setTimeout(filterPotCards, 80);
      setTimeout(filterStickyPotCards, 80);
    });

    // Re-filter when bundle root is injected dynamically (quick view / modal)
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (
            node.matches('[data-cosy-bundle-root]') ||
            node.querySelector('[data-cosy-bundle-root]') ||
            node.matches('[data-cosy-sticky-bundle-root]') ||
            node.querySelector('[data-cosy-sticky-bundle-root]')
          ) {
            setTimeout(filterPotCards, 50);
            setTimeout(filterStickyPotCards, 50);
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();